import { buttonStyle } from 'components/buttons/buttonStyle';
import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import { Button } from 'components/ui/button';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useGetTenantConfigurationQuery, useUpdateAdministratorFieldNameMutation } from 'store/api/tenants';
import { useHasPermissions } from 'utils/permissionUtil';
import { useSettingSave } from './useSettingSave';

/** The backend's limit on the name. */
const MAX_LENGTH = 30;

interface AdministratorFieldNameForm {
    administratorFieldName: string;
}

/** The ADMINISTRATOR_FIELD row's value: what the firm calls the field, saved apart from the switch. Empty removes it. */
export function AdministratorFieldNameControl() {
    const { data: tenantConfiguration } = useGetTenantConfigurationQuery();
    const [updateAdministratorFieldName] = useUpdateAdministratorFieldNameMutation();
    const save = useSettingSave();
    // Until the stored name is in, the field reads empty and a Save would clear it.
    const disabled = !useHasPermissions(['UPDATE.BACK_OFFICE_SETTINGS']) || !tenantConfiguration;
    const { control, handleSubmit } = useForm<AdministratorFieldNameForm>({
        values: { administratorFieldName: tenantConfiguration?.administratorFieldName ?? '' },
    });

    return (
        <>
            <TextInput<AdministratorFieldNameForm>
                control={control}
                name="administratorFieldName"
                label="back-office-settings.ADMINISTRATOR_FIELD.value-label"
                placeholder="back-office-settings.ADMINISTRATOR_FIELD.default-name"
                maxLength={MAX_LENGTH}
                disabled={disabled}
                wrapperClassName="w-[280px]"
            />
            <Button
                {...buttonStyle({ variant: 'contained', color: 'secondary' }, 'h-9')}
                disabled={disabled}
                onClick={() =>
                    void handleSubmit(({ administratorFieldName }) =>
                        save(() =>
                            updateAdministratorFieldName({
                                administratorFieldName: administratorFieldName.trim() || null,
                            }).unwrap()
                        )
                    )()
                }
            >
                <FormattedMessage id="save" />
            </Button>
        </>
    );
}
